import { filtersHelper } from '@/utils';

export const notificationIconModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name || '',
    url: data.url ||  '',
    isActive: data.is_active == null ? true : Number(data.is_active) === 1,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    deletedAt: data.deleted_at || null,
});
